<template>
  <v-app v-resize="onResize" v-scroll="onScroll">
    <!-- Sidenav -->
    <v-navigation-drawer
      app
      v-model="drawer.open"
      :touchless="drawer.touchless"
      floating
      temporary
      right
    >
      <v-list class="pa-1">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>Menu</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-subheader>Navigation</v-subheader>
      <v-list class="pt-0" dense>
        <v-list-tile v-for="item in navbar.items" :key="item.title" :to="item.path">
          <v-list-tile-action>
            <v-icon class="text-center">fa-{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-list class="pt-0" dense>
        <v-list-tile>
          <v-list-tile-content>
            <v-btn
              href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=FJC4738A9TLRL&source=url"
              block
              outline
              color="grey darken-1"
            >Support</v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <!-- Navbar -->
    <v-toolbar
      app
      fixed
      dark
      :flat="navbar.flat"
      :dense="navbar.dense"
      :height="navbar.height"
      :class="navbar.background"
      id="navbar"
    >
      <v-toolbar-title>
        <router-link to="/" class="menu-logo">
          <img src="./assets/ucc-logo-white-3.png" />
        </router-link>
      </v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          v-for="item in navbar.items"
          :key="item.title"
          :to="item.path"
          small
          flat
        >{{ item.title }}</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=FJC4738A9TLRL&source=url"
          small
          flat
          class="hidden-sm-and-down"
        >Support</v-btn>
        <v-btn small flat class="hidden-xs-only" @click="toggleSearch">
          <v-icon class="mr-2">search</v-icon>
          <span>Search</span>
        </v-btn>
        <v-btn icon class="hidden-sm-and-up" @click="toggleSearch">
          <v-icon>search</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-side-icon @click="toggleSidenav" class="hidden-md-and-up"></v-toolbar-side-icon>
    </v-toolbar>

    <!-- Content -->
    <router-view />

    <!-- Footer -->
    <v-footer height="auto" color="grey lighten-4">
      <v-container class="pb-0" grid-list-lg>
        <v-layout row wrap fill-height justify-center align-center xs12>
          <v-flex xs12 sm5 lg5 xl4>
            <v-list dense class="transparent">
              <template v-for="(item, i) in items">
                <v-subheader
                  v-if="item.header"
                  :key="item.header"
                  class="black--text"
                >{{ item.header }}</v-subheader>

                <v-divider v-else-if="item.divider" :inset="item.inset" :key="i"></v-divider>

                <v-list-tile v-else :key="item.title">
                  <v-list-tile-action>
                    <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.title"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
            <v-divider class="grey my-2"></v-divider>
            <v-list dense class="transparent">
              <template v-for="(item, i) in items2">
                <v-subheader
                  v-if="item.header"
                  :key="item.header"
                  class="black--text"
                >{{ item.header }}</v-subheader>

                <v-divider v-else-if="item.divider" :inset="item.inset" :key="i"></v-divider>

                <v-list-tile v-else :key="item.title">
                  <v-list-tile-action>
                    <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.title"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-flex>

          <v-flex xs12 sm7 lg7 xl8>
            <google-map></google-map>
          </v-flex>
          <v-flex text-xs-center xs12>
            <v-btn
              v-for="(item, i) in navbar.items"
              :key="i"
              :to="item.path"
              flat
              round
            >{{ item.title }}</v-btn>
          </v-flex>
        </v-layout>
        <v-divider class="grey"></v-divider>
        <v-layout>
          <v-flex py-2 text-xs-center xs12>
            <strong>&copy;2019 — Union with Christ Community Church. All Rights Reserved.</strong>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>

    <v-btn
      v-show="sermon"
      @click="toggleAudioPlayer"
      color="black"
      dark
      round
      large
      fixed
      bottom
      right
    >
      <span class="mr-3">Return to Sermon</span>
      <v-icon>play_circle_outline</v-icon>
    </v-btn>

    <!-- Player -->
    <v-navigation-drawer v-model="audioPlayer" width="540" fixed temporary dark>
      <!-- <v-layout id="sermon-player">
      <v-flex xs12 md6>-->
      <v-toolbar flat color="transparent">
        <v-toolbar-title>
          <router-link to="/" class="menu-logo">
            <img src="./assets/ucc-logo-white-3.png" />
          </router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="audioPlayer = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <sermon-player ref="player" :sermon="sermon"></sermon-player>
      <!-- </v-flex>
      </v-layout>-->
    </v-navigation-drawer>

    <!-- Search -->
    <v-dialog v-model="searchDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card id="searchbar">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="searchDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>
        <v-container grid-list-lg>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm12 md12 lg8>
              <v-text-field label="Search" @keydown="onKeyDown" v-model="searchString"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm12 md12 lg8>
              <v-radio-group v-model="radioSelection" row @change="onChange">
                <h4>Filter:</h4>
                <v-radio label="Sermons" :value="1"></v-radio>
                <v-radio label="Events" :value="2"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm12 md12 lg8>
              <h5 class="headline mt-3">Results:</h5>
              <div class="mt-3" v-bind:class="{ listBorder: filteredResults.length >=1 }">
                <v-list three-line v-if="radioSelection===1">
                  <template v-for="(sermon, index) in filteredResults">
                    <v-list-tile :key="sermon.title" avatar @click="playSermon(sermon)">
                      <v-list-tile-avatar>
                        <img :src="cover(sermon, 1)" />
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <span class="caption">{{ date(sermon) }}</span>
                        <v-list-tile-title v-html="sermon.title"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="sermon.scripture"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="index+1 !== filteredResults.length" :key="index" :inset="true"></v-divider>
                  </template>
                </v-list>

                <v-list three-line v-else>
                  <template v-for="(event, index) in filteredResults">
                    <v-list-tile :key="event.title" avatar @click>
                      <v-list-tile-avatar>
                        <img :src="eventCover(event)" />
                      </v-list-tile-avatar>

                      <v-list-tile-content>
                        <span class="caption">{{ eventDate(event.startDate, event.endDate) }}</span>
                        <v-list-tile-title v-html="event.title"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="event.subtitle"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="index" :inset="true"></v-divider>
                  </template>
                </v-list>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { bus } from "./main";
import GoogleMap from "./components/GoogleMap";
import SermonPlayer from "./components/SermonPlayer";
import AuthenticationService from "@/services/AuthenticationService";
import ImageMixin from "@/mixins/imageMixin";
export default {
  name: "App",
  components: {
    GoogleMap,
    SermonPlayer
  },
  data() {
    return {
      offsetTop: 0,
      drawer: {
        open: null,
        touchless: null
      },
      searchDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      navbar: {
        items: [
          { title: "About", icon: "info-circle", path: "/about" },
          { title: "Sermons", icon: "microphone", path: "/sermons" },
          { title: "Events", icon: "calendar-alt", path: "/events" },
          { title: "Ministries", icon: "user-plus", path: "/ministries" },
          { title: "Resources", icon: "archive", path: "/resources" }
        ],
        flat: true,
        background: "dark-gradient-transparent",
        dense: false,
        height: 64
      },
      items: [
        { header: "Sunday Worship Service" },
        {
          icon: "access_time",
          title: "Every Sunday starts at 9:30am"
        },
        {
          icon: "place",
          title: "Hemady Square 6th Floor E. Rodriguez Ave corner Hemady St."
        }
      ],
      items2: [
        {
          header:
            "IF YOU HAVE ANY QUESTIONS OR CONCERNS, PLEASE DO NOT HESITATE TO CONTACT US"
        },
        {
          icon: "phone",
          title: "(02) 8287-7004"
        },
        {
          icon: "email",
          title: "writetouccc@gmail.com"
        },
        {
          icon: "fab fa-facebook",
          title: "facebook.com/uccchurch"
        }
      ],
      right: true,
      audioPlayer: null,
      sermon: null,
      // for search
      radioSelection: 1,
      events: [],
      sermons: [],
      filteredResults: [],
      searchString: ""
    };
  },
  mounted() {
    this.getSermons();
    this.getEvents();
  },
  methods: {
    async getSermons() {
      const response = await AuthenticationService.getSermons();
      this.sermons = response.data;
    },
    async getEvents() {
      const response = await AuthenticationService.getEvents();
      this.events = response.data;
    },
    onKeyDown(e) {
      // if(e.key ==='Backspace' && this.searchString.length !=0){
      //   this.searchString = this.searchString.substring(0,this.searchString.length-1);
      // }

      // if( (e.keyCode >= 65 &&  e.keyCode <= 90)){
      //   this.searchString+= e.key.toLowerCase();
      // }

      // else if((e.keyCode >= 48 &&  e.keyCode <= 57) || (e.keyCode == 32 )){
      //   this.searchString+=e.key;
      // }

      if (this.radioSelection === 1) {
        this.filterBySermon(this.searchString.toLowerCase());
      } else {
        this.filterByEvents(this.searchString.toLowerCase());
      }

      if (e.key === "Backspace" && this.searchString.length - 1 === 0) {
        this.resetFilter();
      }
    },
    onChange(e) {
      this.searchString = "";
      this.resetFilter();
    },
    filterByEvents(searchString) {
      this.filteredResults = this.events.filter(event => {
        return (
          event.title.toLowerCase().includes(searchString) ||
          event.subtitle.toLowerCase().includes(searchString) ||
          event.place.toLowerCase().includes(searchString) ||
          event.address.toLowerCase().includes(searchString) ||
          event.description.toLowerCase().includes(searchString)
        );
      });
    },
    filterBySermon(searchString) {
      this.filteredResults = this.sermons.filter(sermon => {
        //property checks huhuuh
        if (!sermon.hasOwnProperty("scripture")) {
          sermon.scripture = "";
        } else if (!sermon.hasOwnProperty("series")) {
          sermon.series = "";
        }
        return (
          sermon.title.toLowerCase().includes(searchString) ||
          sermon.speaker.toLowerCase().includes(searchString) ||
          sermon.scripture.toLowerCase().includes(searchString) ||
          sermon.series.toLowerCase().includes(searchString)
        );
      });
    },
    resetFilter() {
      this.filteredResults = [];
    },
    playSermon(sermon) {
      this.searchDialog = false;
      bus.$emit("playSermon", sermon);
    },
    onResize(e) {
      this.transformNavbar(e);
      if (window.innerWidth > 960) {
        this.drawer.open = false;
        this.drawer.touchless = true;
      } else {
        this.drawer.touchless = false;
      }
    },
    onScroll(e) {
      this.transformNavbar(e);
    },
    transformNavbar(e) {
      this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.offsetTop >= 100 || window.innerWidth < 960) {
        this.navbar.background = "dark-transparent";
        this.navbar.flat = false;
        this.navbar.dense = true;
        this.navbar.height = 56;
      } else {
        this.navbar.background = "dark-gradient-transparent";
        this.navbar.flat = true;
        this.navbar.dense = false;
        this.navbar.height = 64;
      }
    },
    toggleSidenav(e) {
      this.drawer.open = !this.drawer.open;
    },
    toggleSearch(e) {
      this.searchDialog = !this.searchDialog;
    },
    toggleAudioPlayer() {
      this.audioPlayer = !this.audioPlayer;
    },
    startSermon(sermon) {
      this.sermon = sermon;
      this.toggleAudioPlayer();
      this.$refs.player.loadSermon();
    }
  },
  created() {
    bus.$on("playSermon", data => {
      this.startSermon(data);
    });
  },
  mixins: [ImageMixin]
};
</script>

<style>
#app {
  margin: 0;
  font-family: "Lato", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  background-color: #fff;
}
#searchbar .v-toolbar__content {
  max-width: 1000px;
  margin: auto;
}
#searchbar .v-input--radio-group .v-input__control {
  max-width: 400px;
  width: 100%;
}
#searchbar .v-input--radio-group__input {
  justify-content: space-between;
}
#searchbar .listBorder {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
#searchbar .v-list {
  padding: 0;
}
#navbar {
  transition: height 300ms linear, background-color 300ms linear;
}
#navbar .v-toolbar__content {
  max-width: 1185px;
  margin: auto;
}
.transparent {
  background: transparent;
}
.dark-gradient-transparent {
  background: linear-gradient(to bottom, #444, transparent) !important;
}
.dark-transparent {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.menu-logo {
  display: block;
  height: 52px;
  transition: height 250ms ease;
  margin-right: 10px;
}
.menu-logo img {
  max-height: 100%;
  border: 0;
}
.banner-title {
  margin: 0;
  padding: 0 32px;
  /* color: #fff; */
  font-size: 45px;
  line-height: 48px;
  font-weight: 900;
  text-align: center;
}
.section-title {
  /* padding: 4px; */
  text-transform: uppercase;
  letter-spacing: 0.3em !important;
}
.f-grow-0 {
  flex-grow: 0 !important;
}
#sermon-player {
  height: calc(100% - 56px);
}
@media (min-width: 600px) {
  .banner-title {
    padding: 0 48px;
    font-size: 56px;
    line-height: 84px;
  }
}
@media (max-width: 960px) {
  #content {
    margin-top: 56px;
  }
}
@media (min-width: 960px) {
  .banner-title {
    font-size: 72px;
    line-height: 96px;
  }
  #sermon-player {
    height: calc(100% - 64px);
  }
}
@media (min-width: 1264px) {
  .banner-title {
    font-size: 96px;
    line-height: 114px;
  }
}
@media (min-width: 1904px) {
  #searchbar .v-toolbar__content {
    max-width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue